import { useIntl } from "react-intl";
import { SimpleEntityGrid } from "src/app/components/grid/SimpleEntityGrid";
import useUrlsAnalyzedGridActions from "./useUrlsAnalyzedGridActions";
import useUrlsAnalyzedGridColumns from "./useUrlsAnalyzedGridColumns";
import { object } from "yup";
import { UrlMetricsTransport } from "src/app/transports/urlMetrics";
import { AddBoostToOrderModelContainer } from "src/app/containers";
import { useState } from "react";
import useUrlsAnalyzedGridToolbarButtons from "./useUrlsAnalyzedGridToolbarButtons";
import { TSelectedRows } from "src/app/containers/AddBoostToOrderModel/AddBoostToOrderModelContainer";

const UrlsAnalyzedGrid = () => {
    const { formatMessage } = useIntl();

    const [showBoostModal, setShowBoostModel] = useState(false);
    const [selectedRows, setSelectedRows] = useState<TSelectedRows[]>();
    const [orderToUpdateGrid, setValueToUpdateGrid] = useState(false);

    const actions = useUrlsAnalyzedGridActions();
    const gridColumns = useUrlsAnalyzedGridColumns();

    function handleAddBoostOrders(obj: any) {
        setSelectedRows(
            obj.selectedRows.map((el: any) => ({
                id: el.orderId,
                keyword: el.keyword,
                orderType: el.orderType,
                url: el.url,
            }))
        );
        setShowBoostModel(true);
    }

    function handleClose() {
        setShowBoostModel(false);
    }

    function orderAsSendToUpdateGrid() {
        setValueToUpdateGrid(false);
    }

    function handlerValueToUpdateGrid(update: boolean) {
        setValueToUpdateGrid(update);
    }

    const toolbarButtonAction = useUrlsAnalyzedGridToolbarButtons(handleAddBoostOrders);

    return (
        <>
            <SimpleEntityGrid
                //GRID
                columns={gridColumns}
                listHandler={UrlMetricsTransport.urlMetricsForAnalyzePage}
                orderToUpdateGrid={orderToUpdateGrid}
                orderAsSendToUpdateGrid={orderAsSendToUpdateGrid}
                //ACTIONS
                actions={actions}
                //EDIT
                entityName={formatMessage({ id: "common.entity.site" })}
                formBody={() => <></>}
                formTransformer={() => {}}
                formUpdateBody={() => <></>}
                saveHandler={() => {}}
                validationSchema={object({})}
                toggleActiveHandler={async () => {}}
                //TOOLBAR
                toolbarButtonAction={toolbarButtonAction}
            />
            {selectedRows && (
                <AddBoostToOrderModelContainer
                    selectedRows={selectedRows}
                    handlerValueToUpdateGrid={handlerValueToUpdateGrid}
                    handleClose={handleClose}
                    showModal={showBoostModal}
                />
            )}
        </>
    );
};

export default UrlsAnalyzedGrid;
